// extracted by mini-css-extract-plugin
module.exports = {"homeBuyPremiumBadge":"Home_homeBuyPremiumBadge__YazXu"};